import { APIParser, APIParserHtml } from "./api-parser";
import { API_URL, NEW_API_URL  } from "./api-client";
import { getToken } from "./api-util";
import { config } from "../../util/axios-config";
import triyoAPI from "./triyo";

const authMvc = window["APP_SETTINGS"].AUTH_MVC;
/*
    Profile Gets
*/
export const GetProfile = () => {
  if (authMvc === "TRUE") {
    return fetch(API_URL + "/GetUserProfile/" + "0" + "/1", {
      method: "GET",
      credentials: "include",
    }).then((response) => {
      if (response.ok) {
        return APIParser(response);
      } else {
        return null;
      }
    });
  } else {
    let myHeaders = new Headers();
    let token = getToken();
    myHeaders.append("Authorization", `Bearer ${token}`);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(NEW_API_URL + "user/legacy/profile", requestOptions).then(
      (response) => APIParser(response)
    );
  }
};


export const EditProfile = (profile) => {
  let profileJson = JSON.stringify(profile);

  return fetch(API_URL + "/SetUserProfile/" + "0", {
    method: "POST",
    body: profileJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserHtml(response));
};

export const GetProfileNew = () => {
  return triyoAPI.get("/Users/GetUserProfile", config());
};

export const EditProfileNew = (data) => {
  return triyoAPI.post("/Users/EditUser",data, config());
};
